exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-errors[data-v-d351f9c4] {\n    color: red;\n}\n", ""]);

// exports
